/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 16:50:18
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/backtop.js
 */
export default {
    // backtop组件
    backtop: {
        mode: 'circle',
        icon: 'arrow-upward',
        text: '',
        duration: 100,
        scrollTop: 0,
        top: 400,
        bottom: 100,
        right: 20,
        zIndex: 9,
        iconStyle: () => ({
            color: '#909399',
            fontSize: '19px'
        })
    }
}
